__turbopack_context__.v({
  "actions": "VyD1Za_actions",
  "column": "VyD1Za_column",
  "customSectionWrapper": "VyD1Za_customSectionWrapper",
  "divider": "VyD1Za_divider",
  "footer": "VyD1Za_footer",
  "panel": "VyD1Za_panel",
  "radioGrid": "VyD1Za_radioGrid",
  "radioGroup": "VyD1Za_radioGroup",
  "section": "VyD1Za_section",
  "title": "VyD1Za_title",
  "triggerChip": "VyD1Za_triggerChip",
});
